import React, { SelectHTMLAttributes } from "react";
import {
  _SelectInputWrapper,
  _SelectNativeRoot,
  _SelectNativeSelect,
} from "./Select.styled";
import { _ListPickerInput } from "../ListPicker/ListPicker.styled";
import FlexBox from "../../Components/FlexBox/FlexBox";
import Icon from "../../Foundation/Icon/Icon";
import { useTheme } from "../../Themes/defaultTheme";

type NativeSelectOption<T extends string | number> = {
  value: T;
  label: string;
  disabled?: boolean;
  selected?: boolean;
};

interface NativeSelectProps<T extends string | number = string>
  extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "children"> {
  options: NativeSelectOption<T>[];
  placeholder?: string;
}

interface NativeSelectSingleProps<T extends string | number = string>
  extends NativeSelectProps<T> {
  selection?: T;
}

interface NativeSelectMultipleProps extends NativeSelectProps {
  multiple: true;
}

const NativeSelect = React.forwardRef(
  <T extends string | number = string>(
    props: NativeSelectSingleProps<T> | NativeSelectMultipleProps,
    ref: React.Ref<HTMLSelectElement>
  ) => {
    const { options, style, ...rest } = props;
    const {
      required = false,
      multiple = false,
      placeholder = "",
      defaultValue = required ? "" : undefined,
    } = props;
    const { color: themeColors } = useTheme();
    const optionsWithPlaceholder = [
      {
        value: "" as T,
        label: placeholder,
        disabled: required,
      },
      ...options,
    ];
    return (
      <_SelectNativeRoot {...{ style }}>
        <_SelectNativeSelect
          multiple={multiple}
          {...rest}
          defaultValue={defaultValue}
          ref={ref}
        >
          {optionsWithPlaceholder.map((option, k) => {
            const { label, ...restAttributes } = option;
            return (
              <option key={JSON.stringify(option) + k} {...restAttributes}>
                {label}
              </option>
            );
          })}
        </_SelectNativeSelect>
        <Icon icon="switch_arrow" color={themeColors.greyText2} />
      </_SelectNativeRoot>
    );
  }
);

export default NativeSelect;
